import React, { memo, useCallback, useEffect, useState } from "react";

// utils
import { isEmpty } from "@swiggy-private/js-utils";

// styles
import { Menu, MenuButton, MenuTooltipIconStyled, Overlay } from "./styles";

// icons
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";

// constants
import { TEXTS } from "./contants";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface CartHeaderOptionsProps {
    cartIncognitoModeXp?: boolean;
    isIncognitoCart?: boolean;
    isLottieAnimation: boolean;
    onImpressionToggleSwitch?: (isEnabled: boolean) => void;
    onIncognitoToggleClick?: VoidFunction;
    shouldApplyInverseColor?: boolean;
}

function CartHeaderOptions({
    cartIncognitoModeXp,
    isIncognitoCart,
    onImpressionToggleSwitch,
    onIncognitoToggleClick,
    isLottieAnimation,
    shouldApplyInverseColor,
}: CartHeaderOptionsProps) {
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (cartIncognitoModeXp) {
            onImpressionToggleSwitch?.(isIncognitoCart || false);
        }
    }, [cartIncognitoModeXp, onImpressionToggleSwitch, isIncognitoCart]);

    const handleMenuButtonClick = useCallback(() => {
        setShowTooltip((prev) => !prev);
    }, []);

    const handleTooltipClick = useCallback(() => {
        setShowTooltip(false);
        onIncognitoToggleClick?.();
    }, [onIncognitoToggleClick]);

    if (isEmpty(cartIncognitoModeXp)) {
        // we are rendering null since we have only incognito mode feature in this component
        // if we have more features in future, we can remove this check
        return null;
    }

    return (
        <>
            <MenuButton
                onClick={handleMenuButtonClick}
                aria-label={TEXTS.MENU_OPTIONS_ARIA_LABEL}
                aria-expanded={showTooltip}
            >
                <SpriteIconWeb
                    iconName="kebab16"
                    strokeColor={shouldApplyInverseColor ? "text_inverse_Highest_Emphasis" : "text_Highest_Emphasis"}
                    fillColor={shouldApplyInverseColor ? "text_inverse_Highest_Emphasis" : "text_Highest_Emphasis"}
                />
            </MenuButton>

            <Menu isLottieAnimation={isLottieAnimation} show={showTooltip} isIncognitoCart={isIncognitoCart}>
                <MenuTooltipIconStyled>
                    <SpriteIconWeb
                        iconName="incognitoFilled16"
                        strokeColor="text_inverse_Highest_Emphasis"
                        fillColor="text_inverse_Highest_Emphasis"
                    />
                </MenuTooltipIconStyled>
                <Text
                    variant="V2.body2.neutral.regular"
                    color="text_inverse_Highest_Emphasis"
                    onClick={handleTooltipClick}
                    as="span"
                >
                    {isIncognitoCart ? TEXTS.INCOGNITO_TURN_OFF : TEXTS.INCOGNITO_TURN_ON}
                </Text>
            </Menu>

            <Overlay show={showTooltip} onTouchStart={handleMenuButtonClick} onClick={handleMenuButtonClick} />
        </>
    );
}

export default memo(CartHeaderOptions);
